<template>
  <div class="carrousel">
    <swiper :options="slideOptions">
      <swiper-slide v-for="(item, index) in data" :key="index">
        <img :src="item.img" :alt="$t('common.altImage', { product_name: name, no: index })" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      slideOptions: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        effect: 'fade',
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/the-carrousel.scss';
</style>
